import { IMicrofront } from '@/interfaces/microfront.interface'
import { Cookies } from 'app_alegra_commons/libs'
import { prefixEnvironment } from '../../config/index.js'
import { jwtDecode } from '@/vue/utils/appHelpers'
import { validateToggle } from '../config/feature-toogles/index'

const ENVIROMENT = process.env.VUE_APP_ENVIROMENT
// const prefixEnvironment = ENVIROMENT == 'production' ? '' : 'almost-'

const routes: IMicrofront[] = [
  {
    path: '/',
    name: 'app_alegra_reports_dashboard_frontend',
    domain: `https://${prefixEnvironment}reports-dashboard.alegra.com`,
    typeLoading: 'SSkeletonHome',
  },
  {
    path: '/report/exportables-history',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/annual/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/invoices-open/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/bills-open/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/detailed-tax-report/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/it1/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/general-ledger/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/general-balance/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/sales-by-item/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/sales-by-client/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/sales-by-seller/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/sales/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/items-profit/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/resico',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/ledger-journals/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/transactions/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/income-and-expense/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/accounting',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/ledger-journal-categories/*',
    name: 'app_alegra_reports_frontend',
    domain: `https://${prefixEnvironment}reports-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/report/diot',
    name: 'app_alegra_reports_frontend_next',
    domain: `https://${prefixEnvironment}reports-frontend-next.alegra.com`,
    nameExportedRoutes: 'microDiotSettings',
  },
  {
    path: '/report/*',
    name: 'app_alegra_reports_frontend_vue3',
    domain: `https://${prefixEnvironment}reports-v3.alegra.com`,
  },
  {
    path: '/recurring-invoice/*',
    name: 'app_alegra_recurring_invoices',
    domain: `https://${prefixEnvironment}recurring-invoice.alegra.com`,
  },
  {
    path: '/estimate/*',
    name: 'app_alegra_estimate',
    domain: `https://${prefixEnvironment}estimate.alegra.com`,
  },
  {
    path: '/xml-administrator/*',
    name: 'app_alegra_xml_administrator_mex',
    domain: `https://${prefixEnvironment}xml-administrator.alegra.com`,
  },
  {
    path: '/remission/*',
    name: 'app_alegra_remissions_frontend_vue3',
    domain: `https://${prefixEnvironment}remission.alegra.com`,
  },
  {
    path: '/resolution/*',
    name: 'app_alegra_number_templates_frontend',
    domain: `https://${prefixEnvironment}number-template.alegra.com`,
  },
  {
    path: '/catalogue/*',
    name: 'app_alegra_catalogue',
    domain: `https://${prefixEnvironment}catalogue.alegra.com`,
  },
  {
    path: '/invoice/*',
    name: 'app_alegra_invoice',
    domain: `https://${prefixEnvironment}invoices.alegra.com`,
  },
  {
    path: '/cost-center/*',
    name: 'app_alegra_ledger_cost_centers',
    domain: `https://${prefixEnvironment}ledger-cost-center.alegra.com`,
  },
  {
    path: '/saleTicket/*',
    name: 'app_alegra_invoice',
    domain: `https://${prefixEnvironment}invoices.alegra.com`,
  },
  {
    path: '/payment/*',
    name: 'app_alegra_payments',
    domain: `https://${prefixEnvironment}expenses-payments.alegra.com`,
  },
  {
    path: '/accountant/*',
    name: 'app_alegra_micro_accountant_section',
    domain: `https://${prefixEnvironment}accountant.alegra.com`,
  },
  {
    path: '/accounting/*',
    name: 'app_alegra_ledger_frontend',
    domain: `https://${prefixEnvironment}ledger.alegra.com`,
  },
  {
    path: '/account/*',
    name: 'app_alegra_bank',
    domain: `https://${prefixEnvironment}bank-accounts-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/conciliation/index/*',
    name: 'app_alegra_bank',
    domain: `https://${prefixEnvironment}bank-accounts-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/conciliation/*',
    name: 'app_alegra_bank_reconciliations',
    domain: `https://${prefixEnvironment}bank-reconciliations.alegra.com`,
  },
  {
    path: '/ledger/document-types/*',
    name: 'app_alegra_ledger_document_types',
    domain: `https://${prefixEnvironment}document-types-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/ledger/numerations/*',
    name: 'app_alegra_ledger_numerations',
    domain: `https://${prefixEnvironment}numerations-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/closing-periods/*',
    name: 'app_alegra_closing_periods',
    domain: `https://${prefixEnvironment}closing-periods-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/category/*',
    name: 'app_alegra_ledger_categories',
    domain: `https://${prefixEnvironment}ledger-categories-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/ledger/documents/*',
    name: 'app_alegra_ledger_documents',
    domain: `https://${prefixEnvironment}documents-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/journal/*',
    name: 'app_alegra_ledger_documents',
    domain: `https://${prefixEnvironment}documents-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/tax-conciliator/*',
    name: 'app_alegra_ledger_tax_conciliator',
    domain: `https://${prefixEnvironment}tax-conciliator.alegra.com`,
  },
  {
    path: '/tax-office/*',
    name: 'app_alegra_tax_office',
    domain: `https://${prefixEnvironment}tax-office.alegra.com`,
  },
  {
    path: '/additional-charges/*',
    name: 'app_alegra_other_charges',
    domain: `https://${prefixEnvironment}additional-charges.alegra.com`,
  },
  {
    path: '/company/accounting-configuration/*',
    name: 'app_alegra_ledger_accounting_configuration',
    domain: `https://${prefixEnvironment}accounting-config.alegra.com`,
  },
  {
    path: '/company/edit-email-templates/*',
    name: 'app_alegra_email_whatsapp_templates',
    domain: `https://${prefixEnvironment}email-templates.alegra.com`,
  },
  {
    path: '/company/print-templates/*',
    name: 'app_alegra_pdf_customization_engine',
    domain: `https://${prefixEnvironment}pdf-customization-engine.alegra.com`,
  },
  {
    path: '/company/*',
    name: 'app_alegra_company_frontend',
    domain: `https://${prefixEnvironment}company-next.alegra.com`,
  },
  {
    path: '/item-category/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/custom-field/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/variant-attribute/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/warehouse-transfer/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/warehouse/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/inventory-adjustment/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/item/items-management/*',
    name: 'app_alegra_items_vue3',
    domain: `https://${prefixEnvironment}items-v2.alegra.com`,
    nameExportedRoutes: 'MicroItemsManagement',
  },
  {
    path: '/item/import-preview/*',
    name: 'app_alegra_items_vue3',
    domain: `https://${prefixEnvironment}items-v2.alegra.com`,
    nameExportedRoutes: 'MicroItemsManagementImportPreview',
  },
  {
    path: '/item/import-history/*',
    name: 'app_alegra_items_vue3',
    domain: `https://${prefixEnvironment}items-v2.alegra.com`,
    nameExportedRoutes: 'MicroItemsManagementImportHistory',
  },
  {
    path: '/item/import/*',
    name: 'app_alegra_items_vue3',
    domain: `https://${prefixEnvironment}items-v2.alegra.com`,
    nameExportedRoutes: 'MicroItemsManagementImport',
  },
  {
    path: '/item/bulk-edit-history/*',
    name: 'app_alegra_items_vue3',
    domain: `https://${prefixEnvironment}items-v2.alegra.com`,
    nameExportedRoutes: 'MicroItemsManagementBulkEditHistory',
  },
  {
    path: '/item/bulk-edit/*',
    name: 'app_alegra_items_vue3',
    domain: `https://${prefixEnvironment}items-v2.alegra.com`,
    nameExportedRoutes: 'MicroItemsManagementBulkEdit',
  },
  {
    path: '/item/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/price-list/*',
    name: 'app_alegra_items',
    domain: `https://${prefixEnvironment}items-vue2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/sellers/*',
    name: 'app_seller_frontend',
    domain: `https://${prefixEnvironment}sellers.alegra.com`,
  },
  {
    path: '/minor-expense/*',
    name: 'app_alegra_minor_expenses_dom',
    domain: `https://${prefixEnvironment}minor-expenses.alegra.com`,
  },
  {
    path: '/configuration/*',
    name: 'app_alegra_configuration',
    domain: `https://${prefixEnvironment}setting.alegra.com`,
    vueVersion: 2,
    typeLoading: 'SSkeletonCards',
  },
  {
    path: '/seller/*',
    name: 'al_seller_frontend_vue2',
    domain: `https://${prefixEnvironment}sellers-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/mailer/invoice-history/*',
    name: 'app_alegra_history',
    domain: `https://${prefixEnvironment}history.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/history/*',
    name: 'app_alegra_history',
    domain: `https://${prefixEnvironment}history.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/client/management/*',
    name: 'app_alegra_contacts_frontend',
    domain: `https://${prefixEnvironment}contacts-front-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/client/*',
    name: 'app_alegra_contacts_front',
    domain: `https://${prefixEnvironment}contacts-front-v3.alegra.com`,
    versions: [
      'other',
      'mexico',
      'colombia',
      'republicaDominicana',
      'panama',
      'costaRica',
      'spain',
      'peru',
      'chile',
      'argentina',
    ],
  },
  {
    path: '/client/*',
    name: 'app_alegra_contacts_frontend',
    domain: `https://${prefixEnvironment}contacts-front-v2.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/summary-void-list/*',
    name: 'app_alegra_summaries_fe_per',
    domain: `https://${prefixEnvironment}summaries-fe-per.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/ticket-summary-list/*',
    name: 'app_alegra_ticket_summary_list_assets',
    domain: `https://${prefixEnvironment}ticket-summary-list.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/currency-adjustment/*',
    name: 'app_alegra_currency_adjustment',
    domain: `https://${prefixEnvironment}currency-adjustment.alegra.com`,
  },
  {
    path: '/currency/*',
    name: 'app_alegra_multicurrency_frontend',
    domain: `https://${prefixEnvironment}currency.alegra.com`,
  },
  {
    path: '/initial-data/*',
    name: 'app_alegra_ledger_initial_data',
    domain: `https://${prefixEnvironment}initial-data.alegra.com`,
  },
  {
    path: '/dse-wizard/*',
    name: 'app_alegra_dse_wizard',
    domain: `https://${prefixEnvironment}dse-wizard.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/user/edit-notifications/*',
    name: 'app_alegra_email_invoice_collection_notifications',
    domain: `https://${prefixEnvironment}invoice-collection-notifications.alegra.com`,
  },
  {
    path: '/tax-accountant/*',
    name: 'app_alegra_ledger_tax_accountant',
    domain: `https://${prefixEnvironment}tax-accountant.alegra.com`,
  },
  {
    path: '/income-debit-note/*',
    name: 'app_alegra_income_debit_note',
    domain: `https://${prefixEnvironment}income-debit-notes.alegra.com`,
  },
  {
    path: '/income-payments/*',
    name: 'app_alegra_income_payments',
    domain: `https://${prefixEnvironment}income-payments.alegra.com`,
  },
  {
    path: '/term/*',
    name: 'app_alegra_terms',
    domain: `https://${prefixEnvironment}terms.alegra.com`,
  },
  {
    path: '/stamp-document-received/*',
    name: 'app_alegra_stamp_document_received',
    domain: `https://${prefixEnvironment}stamp-document-received.alegra.com`,
  },
  {
    path: '/perceptions',
    name: 'app_alegra_arg_withholdings',
    domain: `https://${prefixEnvironment}arg-withholdings.alegra.com`,
  },
  {
    path: '/tax',
    name: 'app_alegra_taxes_frontend',
    domain: `https://${prefixEnvironment}taxes-front.alegra.com`,
  },
  {
    path: '/integrations/*',
    name: 'app_alegra_ecommerce_frontend',
    domain: `https://${prefixEnvironment}ecommerce.alegra.com`,
    vueVersion: 2,
  },

  {
    path: '/adjustment-note',
    name: 'app_alegra_debit_notes',
    domain: `https://${prefixEnvironment}debit-notes-next.alegra.com`,
    vueVersion: 2,
  },

  {
    path: '/adjustment-note/',
    name: 'app_alegra_debit_notes',
    domain: `https://${prefixEnvironment}debit-notes-next.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/bill/*',
    name: 'app_alegra_bills',
    domain: `https://${prefixEnvironment}bills-next.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/debit-note',
    name: 'app_alegra_expenses_refunds',
    domain: `https://${prefixEnvironment}refunds.alegra.com`,
  },
  {
    path: '/debit-note/',
    name: 'app_alegra_expenses_refunds',
    domain: `https://${prefixEnvironment}refunds.alegra.com`,
  },
  {
    path: '/returned-document/*',
    name: 'app_alegra_credit_notes_frontend',
    domain: `https://${prefixEnvironment}credit-notes.alegra.com`,
  },
  {
    path: '/support-document',
    name: 'app_alegra_support_document',
    domain: `https://${prefixEnvironment}support-document.alegra.com`,
  },
  {
    path: '/purchase-order/*',
    name: 'app_alegra_purchase_order',
    domain: `https://${prefixEnvironment}purchase-order-next.alegra.com`,
    vueVersion: 2,
  },
  {
    path: '/opening-balance/*',
    name: 'app_alegra_ledger_opening_balance',
    domain: `https://${prefixEnvironment}opening-balance.alegra.com`,
  },
  {
    path: '/workflow/*',
    name: 'app_alegra_sales_optimizer',
    domain: `https://${prefixEnvironment}sales-optimizer.alegra.com`,
    versions: ['colombia'],
  },
]

if (ENVIROMENT == 'testing' || ENVIROMENT == 'local') {
  let moduleTesting = Cookies.get('mf-module-testing')

  if (moduleTesting) {
    moduleTesting = JSON.parse(moduleTesting)
    routes.push({
      path: moduleTesting.route,
      name: moduleTesting.moduleName,
      domain: moduleTesting.domine,
    })
  }
}

// Aplicamos los feature toggles a las rutas

function filterRoutesByVersion(routes: IMicrofront[]): IMicrofront[] {
  routes = routes.filter(route => {
    if (!route.featureToggle) return true
    return validateToggle(route.featureToggle)
  })

  const { applicationVersion } = jwtDecode()

  if (!applicationVersion) {
    return routes // Si no hay versión en el JWT, devolver todas las rutas
  }

  const filteredRoutes: IMicrofront[] = []
  const seenPaths = new Set<string>()

  for (const route of routes) {
    if (seenPaths.has(route.path)) {
      continue // Si ya hemos visto esta ruta, la ignoramos
    }

    if (!route.versions || route.versions.includes(applicationVersion)) {
      filteredRoutes.push(route)
      seenPaths.add(route.path) // Marcar esta ruta como vista
    }
  }

  return filteredRoutes
}

export default filterRoutesByVersion(routes)
